import { Constants } from '../_constants/shared.constants';
export const  successUserProfileInfo=(data)=> {
     return{ type: Constants.userProfileInfo.USER_PROFILE_INFO,data }
     }
